import styled from "styled-components";

export const StyledPrivacy = styled.div<{ color: string, themeColor: string }>`
    background-color: #fff;
    padding: 0 16px;
    p,
    h5,
    h4 {
        margin: 0;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
    }
    header {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: ${(p) => p.themeColor};
        }
    }
    article {
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        h5 {
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            line-height: 19px;

            color: #000000;
        }
        p {
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            color: #000000;
        }
        ul {
            li {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #000000;
            }
        }
        ol {
            li {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #000000;
            }
        }
    }
    .consent-item {
        padding: 16px;
        border-radius: 8px;
        background: #F7F7F7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            a {
                color: ${(p) => p.themeColor};
            }
        }
        .ant-switch-checked {
            background-color: ${(p) => p.color};
        }
    }
`;
